export default {
  mounted(el, binding) {
    const loadImage = () => {
      const imageElement = Array.from(el.children).find(
        el => el.nodeName === 'IMG'
      );
      if (imageElement) {
        imageElement.addEventListener('load', () => {
          setTimeout(() => el.classList.add('loaded'), 100);
        });
        imageElement.addEventListener('error', () => console.error('Image load error'));
        imageElement.src = binding.value;
      }
    };

    const createObserver = () => {
      const options = {
        root: null,
        threshold: 0.1,
        rootMargin: '50px'
      };
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            loadImage();
            observer.unobserve(el);
          }
        });
      }, options);
      
      observer.observe(el);
    };

    if (window['IntersectionObserver']) {
      createObserver();
    } else {
      loadImage();
    }
  }
};
